import { doc, getDoc } from 'firebase/firestore'
import { getFirebaseServices } from '../lib/firebase'
import { savePlannerTask } from '../planner/cloud'
import type { Client } from '../types'
import {
  buildFollowUpTask,
  followUpTaskId,
  taskMatchesLatestInteraction,
} from './safeUtils'

export async function syncLatestFollowUpTask(userId: string, client: Client): Promise<boolean> {
  const desired = buildFollowUpTask(client)
  if (!desired) return false

  const { firestore } = getFirebaseServices()
  const reference = doc(firestore, 'users', userId, 'tasks', followUpTaskId(client.id))
  const snapshot = await getDoc(reference)

  if (snapshot.exists() && taskMatchesLatestInteraction(snapshot.data() as typeof desired, client)) {
    return false
  }

  await savePlannerTask(userId, desired)
  return true
}
